import { PostfixCriteriaSchema } from 'api/apiTypes/postfixCriteria';
import { PostfixFunctionSchema } from 'api/apiTypes/postfixLogic';
import { z } from 'zod';

export const ApiPrivacyConsentConfigurationCategoriesSchema = z.object({
  id: z.string(),
  categoryName: z.string(),
  logic: z.union([PostfixFunctionSchema, PostfixCriteriaSchema]),
});

type ApiPrivacyConsentConfigurationCategories = z.infer<typeof ApiPrivacyConsentConfigurationCategoriesSchema>;

export default ApiPrivacyConsentConfigurationCategories;
